
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.029 1.794c.294 0 .535.24.535.535v11.786a.537.537 0 01-.535.536H2.243a.537.537 0 01-.536-.536V2.329c0-.294.241-.535.536-.535h11.786zm0-1.072H2.243c-.887 0-1.607.72-1.607 1.607v11.786c0 .887.72 1.607 1.607 1.607h11.786c.887 0 1.607-.72 1.607-1.607V2.329c0-.887-.72-1.607-1.607-1.607zm-2.01 6.897H8.74V4.34a.403.403 0 00-.402-.403h-.402a.403.403 0 00-.402.402V7.62H4.252a.403.403 0 00-.402.402v.402c0 .221.18.402.402.402h3.281v3.281c0 .221.18.402.402.402h.402c.22 0 .401-.18.401-.402V8.825h3.282c.22 0 .402-.181.402-.402v-.402a.403.403 0 00-.402-.402z","fill":"#8A94A6"}})])
          )
        }
      }
    